<template>
    <div class="variable-income my-3">
        <b-row>
            <div v-if="show_contribution">
                <b-col cols="8">
                    <b-form-group label="EPF Amount">
                        <b-form-input
                        v-model="form.epf"
                        type="text"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="8">
                    <b-form-group label="SOCSO Amount">
                        <b-form-input
                        v-model="form.socso"
                        type="text"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </div>
            <b-col cols="12">
                <el-checkbox v-model="form.epf_excluded" class="mb-3">Exclude EPF</el-checkbox>
            </b-col>

            <b-form>
                <b-col cols="12">
                    <b-form-group label="Total Non-Sales Related Variable Income - OT, Meal Allowances..etc">
                        <b-row>
                            <b-col md="auto" cols="12"
                            class="d-flex align-items-center my-2"
                            v-for="(variable, index) in variables" :key="index">
                                <CurrencyInput
                                    v-model="variable.amount"
                                    :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                    :inputPlaceholder="`Month ${index + 1}`"
                                />
                            </b-col>
                        </b-row>
                    </b-form-group>
                    <b-button-group class="w-100">
                        <b-button @click="addMonths" :disabled="variables.length >= 12" variant="outline-primary" class="mt-3">+ Add</b-button>
                        <b-button @click="removeMonths" :disabled="variables.length <= 0" variant="outline-danger" class="mt-3">- Remove</b-button>
                    </b-button-group>
                </b-col>
                <!-- <b-col cols="4" class="mt-3">
                    <b-button block variant="primary" type="submit">Save</b-button>
                </b-col> -->
            </b-form>
        </b-row>
    </div>
</template>
<script>
    import { Button,  Checkbox } from 'element-ui'
    import { mapActions } from 'pinia'
    import { useCustomerStore } from '@/stores/customerStore'
    import { gEventBus } from '@/assets/js/EventBus/gEventBus.js'
    import CurrencyInput from '@/components/CurrencyInput'

    export default {
        props: ['show_contribution', 'customer'],
        components: {
            CurrencyInput,
            [Button.name]: Button,
            [Checkbox.name]: Checkbox,
        },
        computed:{
            variables(){
                return _gHlp.getValue(this.customer,'incomes.variable',[]) 
            }
        },
        data() {
            return {
                form: {
                    epf: '',
                    socso: '',
                    epf_excluded: this.customer.incomes.main.is_ex_epf_vi ?? false
                }
            }
        },
        created(){
					gEventBus.$on('collect-income-data', this.sendIncomeData);
        },
        beforeDestroy() {
					gEventBus.$off('collect-income-data', this.sendIncomeData);
        },
        methods: {
            ...mapActions(useCustomerStore, ['getCustomer']),
            setData(){
                let variables = _gHlp.isEmpty(this.variables) ? [] : this.variables.map(obj => {
                    return {
                        ...(obj.customer_variable_income_id && { customer_variable_income_id: obj.customer_variable_income_id }),
                        amount:obj.amount
                    }
                })

                let data = {
                    variables:variables,
                    is_ex_epf_vi: this.form.epf_excluded,
                }

                if(this.show_contribution){
                    data = { ...data, gov_epf: this.form.epf, gov_sosco: this.form.socso};
                }

                return data
            },
            sendIncomeData(){
                this.$emit('income-data-collected', this.setData());
            },
            removeMonths() {
							if (this.variables.length > 0) {
                    this.variables.pop();
              }
            },
						addMonths() {
							if (this.variables.length < 12) {
									this.variables.push({amount: null});
							}
            }
        }
    }
</script>